import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from './MenuAccountDropdownProfileLink.module.scss';

interface IMenuAccountDropdownProfileLink {
  to: string;
  children: React.ReactNode;
  disabled?: boolean;
  variant?: 'default' | 'referral';
}

const MenuAccountDropdownProfileLink = ({
  to,
  disabled = false,
  variant = 'default',
  children,
}: IMenuAccountDropdownProfileLink) => {
  const linkClassNames = [
    styles['profile-navigation-link'],
    disabled ? styles['profile-navigation-link--disabled'] : '',
    variant === 'referral' ? styles['profile-navigation-link--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <NavLink
      className={({ isActive }) => (isActive ? styles['navigation-active'] : '')}
      to={to}
      onClick={(e) => {
        if (!disabled) {
          return;
        }

        e.preventDefault();
      }}
    >
      <div className={linkClassNames}>
        <div className={styles['profile-navigation-link__tile']}>{children}</div>
      </div>
    </NavLink>
  );
};

export default MenuAccountDropdownProfileLink;
